import { sim_cardService } from '../_services';
import { router } from '../_helpers';

const state = { onRequest: false, sim_cards: [], sim_card: {} };

const actions = {
    get({ dispatch, commit }, id) {
        commit('request');

        sim_cardService.get(id)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    add({ dispatch, commit }, data) {
        commit('request');

        sim_cardService.add(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/sim_cards');
                    dispatch('alert/success', "Sim Card Added Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/sim_cards');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    edit({ dispatch, commit }, data) {
        commit('request');

        sim_cardService.edit(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/sim_cards');
                    dispatch('alert/success', "Sim Card Updated Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/sim_cards');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    get_all({ dispatch, commit }) {
        commit('request');

        sim_cardService.get_all()
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    destroy({ dispatch, commit }, id){
      commit('request');

      sim_cardService.destroy(id)
          .then(
              async () => {
                  commit('success');
                  await router.go('/sim_cards');
                  dispatch('alert/success', "Sim Card Deleted Successfully", { root: true });
              },
              async error => {
                  commit('error');
                  await router.go('/sim_cards');
                  dispatch('alert/error', error, { root: true });
              }
          );
    },
    get_sim_card_by_account({ dispatch, commit }, data) {
        commit('request');

        sim_cardService.get_sim_card_by_account(data)
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  sim_cards: state => {
    return state.sim_cards
  },
  sim_card: state => {
    return state.sim_card
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.sim_card = {};
        state.sim_cards = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.sim_card = data;
    },
    success_datas(state, data) {
      state.onRequest = false;
      state.sim_cards = data;
    },
    error(state) {
        state.onRequest = false;
    },
};

export const sim_cards = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
